import { createSelector } from 'reselect'

const getContentPerformanceChart = (state: any) => state.contentPerformanceChart

/** A Redux selector to retrieve content performance Chart Data
 * @param state - The Redux state
 * @param {object} - content performance Chart Data.
 */

export const selectContentPerformanceChart = createSelector(
    getContentPerformanceChart,
    (data) => data && data.chartData ? data.chartData : null
)

/** A Redux selector to retrieve content performance Chart Data Loading State
 * @param state - The Redux state
 * @param {boolean} - Boolean value indicating weather content performance chart is loading.
 */

export const selectContentPerformanceChartIsLoading = createSelector(
    getContentPerformanceChart,
    (data) => data && data.status.isLoading ? data.status.isLoading : false
)
